import React from 'react';
import styled from 'styled-components';
import { registry } from '../../core/Registry.js';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${props => props.align === 'center' ? 'center' : (props.align === 'right' ? 'flex-end' : 'flex-start')};
  gap: 15px;
  flex-wrap: wrap;
  margin-bottom: 20px;
  padding: 10px 0;
  border-top: 1px solid var(--glass-border);
  border-bottom: 1px solid var(--glass-border);
`;

const MetaItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: var(--text-secondary);

  svg {
    width: 14px;
    height: 14px;
    color: var(--accent);
  }
`;

const PostMetaWidget = ({ node }) => {
  const align = node.style?.desktop?.align || 'left';
  
  const showAuthor = node.content?.showAuthor !== false;
  const showDate = node.content?.showDate !== false;
  const showComments = node.content?.showComments !== false;

  return (
    <Wrapper align={align}>
      {showAuthor && (
        <MetaItem>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2M12 11a4 4 0 100-8 4 4 0 000 8z"></path></svg>
          Max Mustermann
        </MetaItem>
      )}
      {showDate && (
        <MetaItem>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><path d="M16 2v4M8 2v4M3 10h18"></path></svg>
          24. Oktober 2026
        </MetaItem>
      )}
      {showComments && (
        <MetaItem>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"></path></svg>
          12 Kommentare
        </MetaItem>
      )}
    </Wrapper>
  );
};

registry.register('post_meta', {
  label: 'Post Meta',
  icon: '📅',
  category: 'dynamic',
  defaultContent: { showAuthor: true, showDate: true, showComments: true },
  defaultStyle: { desktop: { align: 'left' } },
  render: PostMetaWidget,
  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'Sichtbarkeit',
          fields: [
            { name: 'content.showAuthor', label: 'Autor anzeigen', type: 'select', options: [{label:'Ja',value:true},{label:'Nein',value:false}] },
            { name: 'content.showDate', label: 'Datum anzeigen', type: 'select', options: [{label:'Ja',value:true},{label:'Nein',value:false}] },
            { name: 'content.showComments', label: 'Kommentare anzeigen', type: 'select', options: [{label:'Ja',value:true},{label:'Nein',value:false}] }
          ]
        }
      ]
    }, {
      tab: 'style', groups: [{ title: 'Layout', fields: [{name:'style.desktop.align', label:'Ausrichtung', type:'select', options:[{label:'Links',value:'left'},{label:'Zentriert',value:'center'}]}] }]
    }
  ]
});
